"use strict";

export function initInScope ($scope) {
    $scope.find('.js-floating-datepicker__input').on('change',function (e) {
        $(this).closest('.js-datepicker').find('.js-floating-datepicker').addClass('has-value');
    });
}
